import { dateToView } from "helpers/date";
import React from "react";
import { GeoJSON, Popup, Tooltip } from "react-leaflet";

export default function RegionDryingPeriods({ regionDryingPeriods, regionDryingPeriodIds, currentBid }) {
    return regionDryingPeriods?.map((el, index) => {
        if (el.isDeleted || (currentBid && !(regionDryingPeriodIds || []).includes(el.id))) {
            return null;
        }

        return (
            <GeoJSON
                key={index}
                color="#e5443c"
                fill
                fillOpacity={0.1}
                weight={2}
                data={el.polygon}
                pane="region-drying-periods"
            >
                <Tooltip
                    permanent
                    className="map__tooltip--default leaflet-tooltip--left-align leaflet-tooltip--light"
                    direction="top"
                >
                    <div>
                        Просушка: {dateToView(el.startedAt)} &mdash; {dateToView(el.endedAt)}
                    </div>
                </Tooltip>
                <Popup className="map__popup mb-0" autoPan={false} closeOnClick closeButton={false}>
                    <div className="py-1 px-2">
                        <div className="font-weight-bold">{el.regionName}</div>
                        <div>
                            Период: {dateToView(el.startedAt)} &mdash; {dateToView(el.endedAt)}
                        </div>
                        {!!el.documentUrl && (
                            <a href={el.documentUrl} target="_blank" rel="noopener noreferrer">
                                Ссылка на нормативный документ
                            </a>
                        )}
                        <div className="small text-muted">{el.description}</div>
                    </div>
                </Popup>
            </GeoJSON>
        );
    });
}
